import { useQuery } from "@tanstack/react-query";
import { useAdminPro } from "api/queries/admin";
import React from "react";
import { aiInterviewInviteQuery } from "../queries";
import { AiInterviewCard } from "./AiInterviewCard";
import { ModalSendAiInterviewLink } from "./ModalSendAiInterviewLink";

type Props = { proId: number };

export function AiInterviewInviteCard({ proId }: Readonly<Props>) {
  const invite = useQuery(aiInterviewInviteQuery({ proId }));
  const { data: pro } = useAdminPro({ id: proId });
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  const phone = pro?.phone_number ?? null;

  return (
    <>
      <AiInterviewCard
        state={invite.data?.current_state ?? "NONE"}
        sent_at={invite.data?.sent_at ?? null}
        expires_at={invite.data?.expires_at ?? null}
        completed_at={invite.data?.completed_at ?? null}
        isLoading={invite.isLoading}
        canSend={Boolean(phone)}
        onSend={() => setIsDialogOpen(true)}
      />
      <ModalSendAiInterviewLink
        proId={proId}
        phone={phone}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
